'use client';
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { X } from 'lucide-react';
import useDevieOs from '@/hook/useDeviceOs';
import BASE_URL from './constants';
import { motion, AnimatePresence } from 'framer-motion';
const AppInstallPopup = () => {
    const [show, setShow] = useState(false);
    const deviceType = useDevieOs(); // 'android' | 'ios' | 'desktop'

    useEffect(() => {
        const timer = setTimeout(() => {
            const isDismissed = Cookies.get('dismissedAppPopup');
            if (!isDismissed) {
                setShow(true);
            }
        }, 2000); // 2000ms = 2 seconds

        return () => clearTimeout(timer); // cleanup on unmount
    }, []);


    const handleClose = () => {
        Cookies.set('dismissedAppPopup', 'true', { expires: 1 });
        setShow(false);
    };

    const [discount, setDiscount] = useState(0);

    useEffect(() => {
        if (!show) return;
        const url = `${BASE_URL}/v1/discount/get-app-discount`;

        fetch(url)
            .then(res => res.json())
            .then(data => {
                const discountPer = data?.response?.discount_per
                if (discountPer) {
                    setDiscount(discountPer);
                }
            })
            .catch(err => {
                console.error("Failed to fetch discount:", err);
            });
    }, [show]);

    if (!show) return null;
    if (!discount) return null;
    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    className="fixed inset-0 z-50 flex justify-center items-center bg-black/50"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <motion.div
                        className="relative w-[360px] md:w-[500px] max-w-[90%] bg-white rounded-xl shadow-xl overflow-hidden"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.8, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        {/* Your modal content here (no change needed) */}
                        <div className="relative text-white p-7 bg-[url('https://res.cloudinary.com/genx21/image/upload/v1750155429/kbbbtxpoqdj1vtxwurxb.webp')] bg-cover">
                            <button
                                onClick={handleClose}
                                className="absolute top-2 right-2 text-white z-10"
                            >
                                <X className="w-5 h-5" />
                            </button>

                            <div className="flex justify-between items-center z-10 relative">
                                <div>
                                    <p className="text-sm md:text-base">Install</p>
                                    <p className="text-lg md:text-xl font-bold">21GenX</p>
                                    <p className="text-sm">APP</p>
                                </div>
                                <div className="text-right">
                                    <p className="text-sm md:text-base">Instant</p>
                                    <p className="text-lg md:text-xl font-bold">{discount}% Extra</p>
                                    <p className="text-sm md:text-base">DISCOUNT</p>
                                </div>
                            </div>

                            {/* Bottom curve effect
                    <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-20 h-10 bg-white rounded-b-full z-0" /> */}

                            {/* Center Logo Overlap */}
                            <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 bg-white p-2 rounded-full  z-10"

                            >
                                <div className=' p-2 rounded-full border border-[#0B65BB]'>
                                    <img
                                        src="https://res.cloudinary.com/genx21/image/upload/v1733467899/images/ymrlt4hltxftbonhpsd3.png"
                                        alt="21GenX-Logo"
                                        className="w-10 h-10 "
                                    />
                                </div>

                            </div>
                        </div>

                        {/* Bottom Section */}
                        <div className="pt-10 pb-5 px-5 text-center">
                            <p className="text-sm mb-4">
                                Download our app for even more features that you can always access on-the-go.
                            </p>
                            <div className=' flex flex-row justify-center gap-5 items-center'>
                                <div className='hidden md:block w-40 h-auto'>
                                    <img height='128px' width='128px' src="https://res.cloudinary.com/genx21/image/upload/v1750156444/xfp0w4yz8ci07d26qwfl.png" alt="Download on the App Store" className="w-32" />
                                </div>

                                <div className="flex md:flex-col justify-center gap-3 items-center">
                                    {(deviceType === 'ios' || deviceType === 'desktop') && (
                                        <a href="https://apps.apple.com/in/app/21genx/id6745773336" target="_blank" rel="noopener noreferrer">
                                            <img src="/assets/icons/app-store-dark.svg" alt="Download on the App Store" className="w-full" />
                                        </a>
                                    )}
                                    {(deviceType === 'android' || deviceType === 'desktop') && (
                                        <a href="https://play.google.com/store/apps/details?id=com.genxproject" target="_blank" rel="noopener noreferrer">
                                            <img src="/assets/icons/google-play.svg" alt="Get it on Google Play" className="w-full" />
                                        </a>
                                    )}
                                </div>
                            </div>

                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>

    );
};

export default AppInstallPopup;
